/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import "./Placeholder.css";

import type { ReactNode } from "react";

export default function Placeholder({ children, className }: { children: ReactNode; className?: string }): JSX.Element {
    return <div className={className || "Placeholder__root"}>{children}</div>;
}
